import React, { useState } from 'react'
import { Input } from 'components'
import { TableRow, TableCell, Avatar, Button, Box } from '@material-ui/core'
import AddPhotoAlternateTwoToneIcon from '@material-ui/icons/AddPhotoAlternateTwoTone'
import PropTypes from 'prop-types'

const getTargetTranslationTitle = (translations, activeLocale) =>
  translations.findEndGetProp(({ locale }) => locale === activeLocale, 'title')

const CategoryForManageCategories = ({
  depth,
  category,
  activeLocale,
  updateCategory,
  deleteCategory,
  disableChange,
}) => {
  // @todo: #roles temporary always true because non-root users should not have access to this component/route
  const can = true

  const [title, changeTitle] = useState(
    can
      ? getTargetTranslationTitle(category.translations, activeLocale)
      : category.title
  )

  const onChange = ({ target: { value } }) => changeTitle(value)
  const [image, changeImage] = useState(null)
  const onFileChange = (event) => {
    changeImage(event.target.files[0])
  }

  return (
    <TableRow>
      {depth > 0 && <TableCell>{'=>'}</TableCell>}
      {depth > 1 && <TableCell>{'=>'}</TableCell>}
      <TableCell colSpan={3 - depth}>
        <Box display="flex" alignItems="center">
          <Box mr={2} mb={2}>
            <Avatar
              src={
                typeof category.media !== 'undefined' && category.media.length
                  ? category.media[0].full_url
                  : ''
              }
            />
          </Box>
          <Input
            input={{
              value: title,
              onChange,
            }}
            meta={{
              touched: true,
              error: !title && 'Required',
            }}
            placeholder={category.title}
          />
        </Box>
      </TableCell>
      <TableCell>
        {!disableChange && (
          <Box display="flex" alignItems="center">
            {title && (
              <Box display="flex" alignItems="center">
                <Box mx={2}>
                  <label htmlFor={`image_${category.id}`}>
                    <AddPhotoAlternateTwoToneIcon />
                    <input
                      style={{ display: 'none' }}
                      id={`image_${category.id}`}
                      type="file"
                      onChange={onFileChange}
                    />
                  </label>
                </Box>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    updateCategory(category.id, {
                      title,
                      locale: activeLocale,
                      image,
                    })
                  }
                >
                  Update
                </Button>
              </Box>
            )}
            <Button onClick={() => deleteCategory(category.id)}>Delete</Button>
          </Box>
        )}
      </TableCell>
    </TableRow>
  )
}

CategoryForManageCategories.defaultProps = {
  disableChange: false,
}

CategoryForManageCategories.propTypes = {
  depth: PropTypes.number.isRequired,
  category: PropTypes.shape().isRequired,
  activeLocale: PropTypes.string.isRequired,
  updateCategory: PropTypes.func.isRequired,
  deleteCategory: PropTypes.func.isRequired,
  disableChange: PropTypes.bool,
}

const NewCategory = ({ depth, addNewCategory }) => {
  const [title, changeTitle] = useState('')
  const [image, changeImage] = useState(null)
  const onFileChange = (event) => {
    changeImage(event.target.files[0])
  }
  const onChange = ({ target: { value } }) => changeTitle(value)
  const random = (Math.random() + 1).toString(36).substring(7)

  return (
    <TableRow>
      {depth > 0 && <TableCell>{'=>'}</TableCell>}
      {depth > 1 && <TableCell>{'=>'}</TableCell>}
      <TableCell colSpan={3 - depth}>
        <Input input={{ value: title, onChange }} />
      </TableCell>
      <TableCell>
        {title && (
          <Box display="flex" alignItems="center">
            <Box mx={2}>
              <label htmlFor={`image_${random}`}>
                <AddPhotoAlternateTwoToneIcon />
                <input
                  style={{ display: 'none' }}
                  id={`image_${random}`}
                  type="file"
                  onChange={onFileChange}
                />
              </label>
            </Box>
            <Button
              onClick={() => addNewCategory(title, image)}
              color="primary"
              variant="contained"
            >
              Add
            </Button>
          </Box>
        )}
      </TableCell>
    </TableRow>
  )
}

NewCategory.propTypes = {
  depth: PropTypes.number.isRequired,
  addNewCategory: PropTypes.func.isRequired,
}

CategoryForManageCategories.New = NewCategory

export default CategoryForManageCategories
